import { useState } from "react";

const BUTTONS = [["resolved", "J’ai compris"], ["again", "Explique autrement"], ["human_help_requested", "Besoin d’un tuteur"], ["needs_practice", "Retour à mon plan"]];

/** Flow 23 (IA): one short explanation + one check question, then a recorded outcome. */
const AiHelpTurnCard = ({ turn, triesLeft, mobileType = false, time, onAction }) => {
  const [state, setState] = useState("open");
  const size = mobileType ? "text-[15px]" : "text-[13px]";
  const parts = [
    turn.explanation && <p key="e" className={`text-[#122118] ${size}`}>{turn.explanation}</p>,
    turn.hint && <p key="h" className={`text-[#2d5a3d] ${size}`}>💡 {turn.hint}</p>,
    turn.question && <p key="q" className={`font-semibold text-[#122118] ${size}`} data-testid="ai-help-question">{turn.question}</p>,
  ].filter(Boolean);
  const [shown, setShown] = useState(1);
  const last = shown >= parts.length;
  const act = async (id) => {
    setState("busy");
    try {
      await onAction(id);
      setState("closed");
    } catch {
      setState("open");
    }
  };
  return (
    <div className="w-[94%] sm:w-[88%] max-w-[23rem] self-start rounded-2xl rounded-tl-sm bg-white p-2.5 sm:p-3 shadow-sm" data-testid="ai-help-turn">
      <p className="text-[11px] font-semibold uppercase tracking-wide text-[#3730a3]">Aide IA · {turn.subject}{turn.theme ? ` · ${turn.theme}` : ""}</p>
      <div className="mt-1 space-y-2">{parts.slice(0, shown)}</div>
      {!last && state !== "closed" && (
        <button type="button" onClick={() => setShown((value) => value + 1)} className={`mt-2 w-full rounded-full bg-[#EEF2FF] px-3 py-2 font-semibold text-[#3730a3] ${size}`} data-testid="ai-help-next">
          Suivant
        </button>
      )}
      {last && state !== "closed" && (
        <div className="mt-2 grid grid-cols-2 gap-1.5">
          {BUTTONS.filter(([id]) => id !== "again" || triesLeft > 0).map(([id, label]) => (
            <button key={id} type="button" disabled={state === "busy"} onClick={() => act(id)} className={`rounded-full border border-gray-200 px-2 py-2 font-semibold text-[#2d5a3d] disabled:opacity-50 ${size}`} data-testid={`ai-help-${id}`}>{label}</button>
          ))}
        </div>
      )}
      <div className="mt-1 text-right text-[10px] text-gray-500">{time}</div>
    </div>
  );
};

export default AiHelpTurnCard;
